import { api } from "api/apiService";

/**
 * Завантажує повний список категорій.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами категорій.
 */
export const fetchCategories = () => {
  return api.get("/categories");
};
